'use client';

import cn from 'classnames';
import { useEffect, useState } from 'react';
import Text, { TextVariant } from '@/components/common/Text/Text';
import './TextWithAnimatedEllipsis.style.scss';

const TextWithAnimatedEllipsis = ({
  text,
  showDots = true,
  textVariant = 'text-s',
  isItalic = false,
  className
}: {
  text: string;
  showDots?: boolean;
  textVariant?: TextVariant;
  isItalic?: boolean;
  className?: string;
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    if (!showDots) return;

    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots.length >= 3) return '';
        return '.'.repeat(prevDots.length + 1);
      });
    }, 300);

    return () => clearInterval(interval);
  }, [showDots]);

  return (
    <div className={cn('text-with-animated-ellipsis', className)}>
      <Text
        variant={textVariant}
        italic={isItalic}
      >
        {text}
        {showDots && dots}
      </Text>
    </div>
  );
};

export default TextWithAnimatedEllipsis;
